import Button from "../../Button";
import React, { useContext } from "react";
import constants from "../../../constants";
import AlertContext from "../../../context/AlertContext";
import InstructionPageWizardHooks from "../../../Hooks/InstructionPage/InstructionPageWizardHooks";

export default function Acknowledgement() {
  const Alert = useContext(AlertContext);

  const InstructionPageWizardHks = InstructionPageWizardHooks();
  const isPreview = new URLSearchParams(window.location.search).get("mode") === "preview";

  return (
    <div className="acknowledgementMainContainer">
      <div className="acknowledgementHeader">
        Welcome to the Proctored Test Experience
        <div className="acknowledgementHeaderDesc">
          To maintain academic integrity, this test will be monitored using your
          webcam
          {Alert.testData.testmode !== constants.MODE.TEST_MODE &&
            " and smartphone"}
          . Please read and agree to the following before proceeding.
        </div>
      </div>
      <div className="acknowledgementBody">
        What You're Agreeing To:
        <ul className="acknowledgementBodyList">
          <li>
            I understand that my webcam will record my face and eye movements
            during the test.
          </li>
          <li>
            I agree not to use mobile phones, other screens, or external help
            during the exam.
          </li>
          <li>
            I am aware that any suspicious behavior (e.g., looking away
            frequently, multiple people in view, switching tabs) may affect my
            confidence score and flag my test for review.
          </li>
          <li>
            I confirm that I am alone in the room, in a quiet environment, and
            ready to begin.
          </li>
        </ul>
        <div className="acknowledgementBodyFooter">
          Your video feed will be used strictly for test monitoring and will not
          be stored or shared beyond this session unless a violation is
          detected.
        </div>
        <div className="acknowledgementBtn">
          <Button
            size="sm"
            onClick={InstructionPageWizardHks.handleNext}
            disable={isPreview}
            hierarchy={{
              type: "primary",
              buttonText: "I Agree",
            }}
          />
        </div>
      </div>
    </div>
  );
}
